import { Fragment } from 'react';

import AthleteUserCredentialsLargeGrid from './AthleteUserCredentialsLargeGrid';
import AthleteUserCredentialsSmallGrid from './AthleteUserCredentialsSmallGrid';

const AthleteUserCredentialsGrid = ({ gridData, isLoading, onDeleteCredentialClicked }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            <p>{gridData.length === 1 ? `${gridData.length} Credential` : `${gridData.length} Credentials`}</p>
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <AthleteUserCredentialsLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onDeleteCredentialClicked={onDeleteCredentialClicked}
      />
      <AthleteUserCredentialsSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onDeleteCredentialClicked={onDeleteCredentialClicked}
      />
    </Fragment>
  )
};

export default AthleteUserCredentialsGrid;